import { Component, effect, input, output, signal } from '@angular/core';
import { RidChevron } from '../rid-chevron/rid-chevron';

@Component({
  selector: 'rid-horizontal-pages',
  imports: [RidChevron],
  templateUrl: './rid-horizontal-pages.html',
  host: {
    class: 'block w-full',
  },
})
export class RidHorizontalPages {
  pageCount = input.required<number>();

  index = signal(0);

  navigated = output<number>();

  constructor() {
    effect(() => this.navigated.emit(this.index()));
  }
}
